import { render, staticRenderFns } from "./dragDropHeroBlock.vue?vue&type=template&id=10711909&"
import script from "./dragDropHeroBlock.vue?vue&type=script&lang=js&"
export * from "./dragDropHeroBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports